module.exports = __webpack_public_path__ + "assets/img/yyindex-5.3c882ccc.png";